import axiosClient from "api/axiosInstance";

export const getSupplyPlanForecast = async (
  productionParkId: number,
  productionDate: string,
): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(
    `/supply-plans/forecast?productionParkId=${productionParkId}&productionDate=${productionDate}`,
  );

  return response.data;
};

export const downloadSupplyPlanForecastTemplate = async (
  date: string,
): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(
    `/supply-plans/forecast-template?date=${date}`,
    {
      responseType: "blob",
    },
  );

  return response.data;
};

export const getSupplyPlanPriceLimits = async (
  productionParkId: number,
  auctionId: number,
): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(
    `/production-parks/${productionParkId}/supply-plans/price-limits?auctionId=${auctionId}`,
  );

  return response.data;
};

export const saveSupplyPlanPriceLimits = async (
  productionParkId: number,
  data: any,
): Promise<any> => {
  const client = axiosClient();

  const response = await client.post(
    `/production-parks/${productionParkId}/supply-plans/price-limits`,
    data,
  );

  return response.data;
};

export const downloadSupplyPlanPriceLimits = async (): Promise<any> => {
  const client = axiosClient();

  const response = await client.post(
    `/supply-plans/price-limits/export`,
    {},
    {
      responseType: "blob",
    },
  );

  return response.data;
};

export const downloadSupplyPlanScheduledTemplate = async (
  date: string,
): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(
    `/supply-plans/schedule-template?date=${date}`,
    {
      responseType: "blob",
    },
  );

  return response.data;
};

export const uploadSupplyPlanScheduled = async (
  clientId: number,
  auctionTypeId: number,
  date: string,
  data: any,
): Promise<any> => {
  const client = axiosClient();

  const response = await client.post(
    `/clients/${clientId}/supply-plans/schedule?auctionTypeId=${auctionTypeId}&date=${date}`,
    { file: data },
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return response.data;
};

export const getSupplyPlanScheduled = async (
  clientId: number,
  auctionTypeId: number,
  date: string,
): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(
    `/clients/${clientId}/supply-plans/schedule?auctionTypeId=${auctionTypeId}&date=${date}`,
  );

  return response.data;
};

export const deleteSupplyPlanScheduled = async (
  clientId: number,
  auctionTypeId: number,
  date: string,
): Promise<any> => {
  const client = axiosClient();

  const response = await client.delete(
    `/clients/${clientId}/supply-plans/schedule?auctionTypeId=${auctionTypeId}&date=${date}`,
  );

  return response.data;
};
